export default __webpack_public_path__ + "static/media/detourage_moi_02_desktop.68c301e9.png";